import { Typography } from '@mui/joy';
import type { SxProps } from '@mui/joy/styles/types';
import type { ReactElement, ReactNode } from 'react';

interface BulletItemProps {
  children: ReactNode;
  sx?: SxProps;
}

const BulletItem = ({ children, sx }: BulletItemProps): ReactElement => {
  return (
    <Typography component="li" level="body-md" display="list-item" sx={sx}>
      {children}
    </Typography>
  );
};

export default BulletItem;
